import { action, payload } from 'ts-action'
import { IError, IPayload } from 'models/Global'
import { IState } from 'models/State'

export const GetStates = action('GetStates', payload<IPayload<IState[]>>())
export const UpdateState = action('UpdateState', payload<IPayload<IState>>())
export const GetStatesErrors = action('GetStatesErrors', payload<IError>())
export const StatesFetching = action('StatesFetching', payload<boolean>())
